export default function Council2016Entries() {
  return (
    <table id="filetable">
      {/*Start Table*/}
      <tr>
        <th>Meeting Date</th>
        <th>Minutes</th>
        <th>Agenda</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>12-30-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-12-30-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}

      {/*Start File*/}
      <tr>
        <td>12-19-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-12-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}

      {/*Start File*/}
      <tr>
        <td>11-21-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-11-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>10-17-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-10-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>09-19-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-09-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>08-15-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-08-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>07-18-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-07-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>06-20-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-06-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>05-16-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-05-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>04-18-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-04-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>03-21-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-03-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>02-16-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-02-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>01-19-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-01-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
      <tr>
        <td>01-04-2016</td>
        <td>
          <a href="../docs/council/minutes/2016/2016-01-04-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>Unavailable</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
